export default "__VITE_ASSET__D0Ea61vp__"